import HeaderConversation from './HeaderConversation';

export default HeaderConversation;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/message-history/header-conversation/index.js